import React from "react";
import { Link } from "react-router-dom";

const ThankPageContact = () => {



  return (
    <section className="section_thank">
      <div className="container">
        <div className="contact_box">
          <div className="icon_box">
            <img src="assets/images/icons/correctBlueArrow16.svg" alt="check" />
          </div>
          <div className="titel">
            <h1 className="border_text">
              Thank You.
            </h1>
          </div>
          <p>We have received your Request and will respond to you as quickly as possible. From 10:00 AM to 06:00 PM, we do our best to respond as quickly as possible, usually within a few hours.</p>
        </div>
        <ul className="list-unstyled social social_thanks_page justify-content-center mb-4">
          <li>
            <Link to={"https://www.facebook.com/ProcoorInternational/"} target="_blank" className="facebook">
              <img src="assets/images/icons/fcbk.svg" alt="facebook" />
            </Link>
          </li>
          <li>
            <Link to={"https://eg.linkedin.com/company/procoor"} target="_blank" className="linkedin">
              <img src="assets/images/icons/lkd-in.svg" alt="facebook" />
            </Link>
          </li>
          <li>
            <Link to={"https://www.instagram.com/procoorinternational"} target="_blank" className="instagram">
              <img src="assets/images/icons/instagram.svg" alt="instagram" />
            </Link>
          </li>
        </ul>
        <div className="btn_back pt-3">
          <Link to={"/"} className="primaryBtn-1 mediumBtn  icon-r btn">Back to Home<img src="assets/images/icons/arrow-right16.svg" className="icon" alt="arrow" /></Link>
        </div>
      </div>

    </section>

  );
};

export default ThankPageContact;
